import { render, staticRenderFns } from "./DlvES_Delivery_Total.vue?vue&type=template&id=20d319df"
import script from "./DlvES_Delivery_Total.vue?vue&type=script&lang=js"
export * from "./DlvES_Delivery_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports